import React from 'react';
import css from './about-stats.module.scss';

export default function AboutStats() {
  return (
    <div className={css.about}>
      <div className={css.content}>
        <div className={css.first}>
          <h3>100+</h3>
          <p>надавачів послуг</p>
        </div>
        <div className={css.second}>
          <h3>1000+</h3>
          <p>локацій на мапі</p>
        </div>
        <div className={css.third}>
          <h3>4</h3>
          <p>етапи перевірки</p>
        </div>
      </div>
    </div>
  );
}
